import {DB, ExecuteResult, SQLBatchTuple} from './index';
import time from '../time';

export type UserRef = {
    uid: number; // 主键
    isfriend: number; // 0 - 不是朋友 1 - 是朋友
    isstaff: number; // 0 - 不是同事 1 - 是同事
    ischain: number; // 0 - 不是同事 1 - 是同事 是不是供应链联系人
    plat: string; // 写上平台方便查
    appkey: string; // 写一份appkey方便查
    main_appkey: string; // 写一份appkey方便查
    lutime: number; // 最后更新时间
    lctime: number; // 记录最早创建时间
};

export type UserRefType = 'friend' | 'staff' | 'chain';
export async function user_ref_upsert(
    db: DB,
    userRef: UserRef,
    updates: UserRefType[],
): Promise<ExecuteResult> {
    if (userRef.appkey.length > 0) {
        userRef.plat = userRef.appkey.charAt(0);
    }
    let sqlstr =
        'insert into t_user_ref(' +
        ' uid, isfriend, isstaff, ischain, plat,' +
        ' appkey, main_appkey, lutime, lctime' +
        ') VALUES (?, ?, ?, ?, ?,' +
        ' ?, ?, ?, ?' +
        ' ) ON CONFLICT(uid) DO UPDATE SET lutime=?';
    const params = [];
    const now = time.toUnixMillSecond(time.now());
    params.push(
        ...[
            userRef.uid,
            userRef.isfriend,
            userRef.isstaff,
            userRef.ischain,
            userRef.plat,
        ],
    );
    params.push(...[userRef.appkey, userRef.main_appkey, now, now]);
    params.push(now);
    for (let i = 0; i < updates.length; i++) {
        const type = updates[i];
        if (type === 'friend') {
            sqlstr += ', isfriend=?';
            params.push(userRef.isfriend);
        } else if (type === 'staff') {
            sqlstr += ', isstaff=?';
            params.push(userRef.isstaff);
        } else if (type === 'chain') {
            sqlstr += ', ischain=?';
            params.push(userRef.ischain);
        }
    }
    return await db.Execute(sqlstr, params);
}

/** 批量写入用户关系 */
export async function user_ref_batch_upsert(
    db: DB,
    userRefs: UserRef[],
    updates: UserRefType[],
): Promise<{ error: any }> {
    const commands: SQLBatchTuple[] = [];
    const now = time.toUnixMillSecond(time.now());
    for (const userRef of userRefs) {
        if (userRef.appkey.length > 0) {
            userRef.plat = userRef.appkey.charAt(0);
        }
        let sqlstr =
            'insert into t_user_ref(' +
            ' uid, isfriend, isstaff, ischain, plat,' +
            ' appkey, main_appkey, lutime, lctime' +
            ') VALUES (?, ?, ?, ?, ?,' +
            ' ?, ?, ?, ?' +
            ' ) ON CONFLICT(uid) DO UPDATE SET lutime=?';
        const params: any[] = [];
        params.push(
            ...[
                userRef.uid,
                userRef.isfriend,
                userRef.isstaff,
                userRef.ischain,
                userRef.plat,
            ],
        );
        params.push(...[userRef.appkey, userRef.main_appkey, now, now]);
        params.push(now);
        for (let i = 0; i < updates.length; i++) {
            const type = updates[i];
            if (type === 'friend') {
                sqlstr += ', isfriend=?';
                params.push(userRef.isfriend);
            } else if (type === 'staff') {
                sqlstr += ', isstaff=?';
                params.push(userRef.isstaff);
            } else if (type === 'chain') {
                sqlstr += ', ischain=?';
                params.push(userRef.ischain);
            }
        }
        commands.push([sqlstr, params]);
    }
    if (commands.length === 0) return { error: null };
    const r = await db.BatchExecute(commands);
    return { error: 'user_ref_batch_upsert error' };
}

export async function user_ref_unset_friend(
    db: DB,
    uid: number,
): Promise<ExecuteResult> {
    const sqlstr = 'update t_user_ref set isfriend=0 where uid=?';
    return await db.Execute(sqlstr, [uid]);
}

export async function user_ref_set_notin(
    db: DB,
    notInUids: number[],
    type: 'friend' | 'staff' | 'chain',
): Promise<ExecuteResult> {
    let cond = '';
    if (type === 'friend') {
        cond = ' isfriend=0';
    } else if (type === 'staff') {
        cond = ' isstaff=0';
    } else if (type === 'chain') {
        cond = ' ischain=0';
    } else {
        return {error: 'BUG!', insertId: 0, rowsAffected: 0};
    }
    const now = time.toUnixMillSecond(time.now());
    let sqlstr = 'update t_user_ref set lutime=?,' + cond;
    if (notInUids.length > 0) {
        sqlstr += ' where uid not in (' + notInUids.join(',') + ')';
    }
    return await db.Execute(sqlstr, [now]);
}

export type UserRefQryCond = {
    uid?: number | undefined; // 主键
    isfriend?: number | undefined; // 0 - 不是朋友 1 - 是朋友
    isstaff?: number | undefined; // 0 - 不是同事 1 - 是同事
    ischain?: number | undefined; // 0 - 不是同事 1 - 是同事 是不是供应链联系人
    plat?: string | undefined; // 写上平台方便查
    appkey?: string | undefined; // 写一份appkey方便查
    andOr?: 'and' | 'or'; // 默认and
};

export async function qry_user_ref(
    db: DB,
    cond: UserRefQryCond,
): Promise<{error: any; data?: UserRef[]}> {
    const conds: string[] = [];
    const params = [];
    if (cond.uid !== undefined) {
        conds.push(`uid= ${cond.uid}`);
    }
    if (cond.isfriend !== undefined) {
        conds.push(`isfriend= ${cond.isfriend}`);
    }
    if (cond.isstaff !== undefined) {
        conds.push(`isstaff= ${cond.isstaff}`);
    }
    if (cond.ischain !== undefined) {
        conds.push(`ischain= ${cond.ischain}`);
    }
    if (cond.plat !== undefined) {
        conds.push(`plat= ${cond.plat}`);
    }
    if (cond.appkey !== undefined) {
        conds.push(`appkey= '${cond.appkey}'`);
    }
    let sqlstr = 'select * from t_user_ref';
    if (conds.length > 0) {
        if (cond.andOr === 'or') {
            sqlstr += ' where ' + conds.join(' or ');
        } else {
            sqlstr += ' where ' + conds.join(' and ');
        }
    }
    const r = await db.Query(sqlstr, []);
    if (r.error) {
        return {error: r.error};
    }
    if (r.data) {
        const d = r.data as UserRef[];
        return {error: null, data: d};
    }
    return {error: null};
}

